const path = 'https://www.larcrea.com'

export default path
